export default __webpack_public_path__ + "static/media/p19.a1ff83b1.jpg";